import * as React from "react";
import { Navigate } from "react-router-dom";
import { isLearningCoachApplicationAccessible } from "../../helpers/LearningCoachApplicationHelper";
import { OutletContextProps } from "../../helpers/RouterHelper";
import { AuthenticatedPageProps } from "../../hocs/enhanceAuthenticatedPage";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import { useFlashMessage } from "../../hooks/useFlashMessage";
import SectionInterface from "../../interfaces/SectionInterface";
import { HTTP_ERROR_MESSAGE } from "../../reducers";
import SectionsLearningCoachApplicationRequests from "./SectionsLearningCoachApplicationRequests";

interface Props
  extends OutletContextProps,
    Pick<AuthenticatedPageProps, "operatorPrivileges"> {
  section: SectionInterface;
}

const SectionsLearningCoachApplicationRequestsPage = ({
  section,
  operatorPrivileges,
  setActiveMenu,
}: Props) => {
  // section は enhanceSectionsPage がロード済みを保証。privileges は並行して読み込まれる
  const privileges = operatorPrivileges.data?.privileges;
  const accessible = isLearningCoachApplicationAccessible(section, privileges);
  const { showErrorMessage } = useFlashMessage();

  React.useEffect(() => {
    if (operatorPrivileges.loadFailed) {
      showErrorMessage(HTTP_ERROR_MESSAGE);
    }
  }, [operatorPrivileges.loadFailed, showErrorMessage]);

  React.useEffect(() => {
    if (accessible) {
      setActiveMenu("learning_coach");
    }
  }, [accessible]);

  // privileges の読み込みを待ってから判定する（読み込み前にリダイレクトしない）
  if (operatorPrivileges.loadFailed || !privileges) {
    return null;
  }

  // ACC-02: ACC-01 の条件を満たさない直接 URL アクセスは校舎のダッシュボードへ移動させる
  if (!accessible) {
    return <Navigate to={`/sections/${section.id}`} replace />;
  }

  return (
    <SectionsLearningCoachApplicationRequests
      section={section}
      privileges={privileges}
    />
  );
};

export default enhanceSectionsPage(
  SectionsLearningCoachApplicationRequestsPage,
  { title: "学習コーチング" },
);
